import { z } from 'zod';
import { EntityType } from '$lib/sanity/types';
import { SanityBlockSchema, SanityDocumentSchema } from '../sanity';
import { SEOSchema } from '../shared/SEO';

export const LegalLicenseSchema = z.object({
  jurisdiction: z.string(),
  jurisdictionLabel: z.string().optional(),
  regulatoryAgency: z.string(),
  licenseNumber: z.string().optional().nullable()
});

export const LegalLicensesJurisdictionInfoSchema = z.object({
  jurisdiction: z.string(),
  info: z.array(SanityBlockSchema)
});

export const LegalLicensesPageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.LegalLicensesPage),
  seoAttributes: SEOSchema.nullable().optional(),
  intro: z.array(SanityBlockSchema).optional(),
  licenses: z.array(LegalLicenseSchema).optional(),
  postTableNotes: z.array(SanityBlockSchema).optional(),
  jurisdictionInfoList: z.array(LegalLicensesJurisdictionInfoSchema).optional(),
  payrollReceiptInformation: z.array(LegalLicensesJurisdictionInfoSchema).optional()
});

export type LegalLicense = z.infer<typeof LegalLicenseSchema>;
export type LegalLicensesJurisdictionInfo = z.infer<typeof LegalLicensesJurisdictionInfoSchema>;
export type LegalLicensesPage = z.infer<typeof LegalLicensesPageSchema>;
